import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { NavigationService } from 'src/services/navigation.service';

interface CarouselSlide {
  img: SafeUrl;
  title: string;
  link: string | null;
}

@Component({
  selector: 'app-home-carousel',
  templateUrl: './home-carousel.component.html',
  styleUrl: './home-carousel.component.scss'
})
export class HomeCarouselComponent implements OnInit {
  slides: CarouselSlide[] = [];
  loading = true;

  constructor(protected navigationService: NavigationService,
    protected sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    // I banner arrivano dall'API (già filtrati per lingua via Accept-Language).
    // "immagine" è l'URL relativo dell'endpoint immagine (con ?v= per il
    // cache-busting); il data-URI base64 resta supportato come fallback.
    this.navigationService.getBanner().subscribe({
      next: (res: any) => {
        this.slides = (res || [])
          .filter((b: any) => b.immagine ?? b.Immagine)
          .map((b: any) => {
            const src: string = b.immagine ?? b.Immagine;
            const url = src.startsWith('data:') || src.startsWith('http') ? src : environment.api + src;
            return {
              img: this.sanitizer.bypassSecurityTrustUrl(url),
              title: b.altDescrizione ?? b.AltDescrizione ?? 'Evok Banner Home',
              link: b.linkAtterraggio ?? b.LinkAtterraggio ?? null
            } as CarouselSlide;
          });
        this.loading = false;
      },
      error: () => {
        this.slides = [];
        this.loading = false;
      }
    });
  }
}
